import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const SitesPage = Loader(lazy(() => import('content/pages/Private/Sites')));

const sitesRouter: RouteObject[] = [
  {
    path: 'sites',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <SitesPage />,
      },
    ],
  },
];

export default sitesRouter;
